module.exports = __webpack_public_path__ + "static/media/Badge_SvgAppConnecte_Bronze.a5ca60ce.svg";